/* eslint-disable camelcase */
import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import Modal from 'components/Modal';
import { Button, Col, Row } from 'react-bootstrap';
import moment from 'moment';
import { addSubscriptionR } from 'actions/SubscriptionsActions';
import FormInput from 'components/forms/FormInput';
import FormAutocomplete from 'components/forms/FormAutocomplete';
import DateTimePicker from 'components/forms/DateTimePicker';
import { getTimezoneFromState } from 'helpers/intl';
import FormSwitchery from 'components/forms/FormSwitchery';
import FormLangInput from 'components/forms/FormLangInput';
import FormLangRichEditor from 'components/forms/FormLangRichEditor';
import IconRadioGroup from 'components/forms/IconRadioGroup';
import Loader from '../Loader';

class SubscriptionNew extends React.Component {
  constructor(props) {
    super(props);
    // const dateDefault = new Date();
    // let dateUntil = new Date();
    // dateUntil = new Date(dateDefault);
    // dateUntil.setMonth(dateUntil.getMonth() + 1); // +1 month
    this.state = {
      description: [],
      fee: 0,
      starting_fee: 0,
      newDateTime: null,
      newDateTimeUntil: null,
      newSubscription: null,
      title: [],
      status: true,
      selectedRoles: [],
      cancelAtPeriodEnd: false,
      type: null,
      billingCycle: 'monthly',
      availabilityPeriod: false,
    };
  }

  setNewDateTime = (_, newDateTime) => {
    this.setState({ newDateTime });
  };

  setNewDateTimeUntil = (_, newDateTimeUntil) => {
    this.setState({ newDateTimeUntil });
  };

  changeNewSubscription = newSubscription => {
    this.setState({ newSubscription });
  };

  changeStatus = status => {
    this.setState({ status });
  };

  changeAvailabilityPeriod = availabilityPeriod => {
    const { newDateTime, newDateTimeUntil } = this.state;
    let newState = { availabilityPeriod };
    if (!availabilityPeriod) {
      newState.newDateTime = null;
      newState.newDateTimeUntil = null;
    } else if (!newDateTime) {
      newState.newDateTime = new Date();
    }

    this.setState(newState);
  };

  checkDisabled = () => {
    const { disabled } = this.props;
    return !!disabled;
  };

  setBillingCycle = value => {
    let { newDateTimeUntil } = this.state;
    if (newDateTimeUntil) {
      const dateDefault = new Date();
      let dateUntil = new Date();
      if (value === 'monthly') {
        dateUntil = new Date(dateDefault);
        dateUntil.setMonth(dateUntil.getMonth() + 1); // +1 month
      } else if (value === 'annual') {
        dateUntil = new Date(dateDefault);
        dateUntil.setFullYear(dateUntil.getFullYear() + 1); // +1 year
      }
      newDateTimeUntil = moment(dateUntil);
    }

    this.setState({ billingCycle: value, newDateTimeUntil, cancelAtPeriodEnd: true });
  };

  onChange = e => {
    const { target } = e;
    const { checked, value: role } = target;

    let newValue;
    if (checked) {
      newValue = [...this.state.selectedRoles, role];
    } else {
      newValue = this.state.selectedRoles.filter(r => r !== role);
    }
    this.setState({ selectedRoles: newValue });
  };

  createSubscription = () => {
    const { addSubscriptionR, closeAddSubscription } = this.props;
    const {
      newDateTime,
      newDateTimeUntil,
      newSubscription,
      title,
      description,
      fee,
      status,
      // cancelAtPeriodEnd,
      starting_fee,
      selectedRoles,
      type,
      billingCycle,
    } = this.state;

    addSubscriptionR({
      type,
      title,
      name: newSubscription,
      description,
      starting_fee,
      fee,
      periodStart: newDateTime,
      periodEnd: newDateTimeUntil,
      isActive: status,
      roles: selectedRoles,
      // cancelAtPeriodEnd: cancelAtPeriodEnd,
      billingCycle,
    });

    closeAddSubscription();
  };

  changeDescription = (_, description) => {
    this.setState({ description });
  };

  changeTitle = (_, title) => {
    this.setState({ title });
  };

  render() {
    const { intl, show, close, appIntl, defaultTimezone, subscriptions, roles } = this.props;
    const {
      newDateTime,
      newDateTimeUntil,
      newSubscription,
      title,
      description,
      fee,
      type,
      availabilityPeriod,
      status,
      billingCycle,
    } = this.state;

    const { messages } = intl;
    const { pending } = subscriptions;

    const type_options = ['item', 'client', 'company', 'clientItem'];
    const isDisabled = [newSubscription, description, fee, type].some(value => value === null);

    const currentDateTime = new Date();

    return (
      <Modal show={show} onHide={close} bsSize="lg">
        <Modal.Header closeButton>
          <Modal.Title>{messages.create_subscription}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col md={12}>
              <div className="form-group form-group-default p-t-10 p-b-10 addSubscriptionForm">
                <FormInput
                  type="text"
                  label={messages.subscription_name}
                  name="subscription_name"
                  onChange={(name, value) => {
                    this.changeNewSubscription(value);
                  }}
                  value={newSubscription}
                  disabled=""
                />
                <FormLangInput
                  label={messages.subscription_title}
                  name="title"
                  value={title}
                  onChange={(name, value) => {
                    this.changeTitle(name, value);
                  }}
                />
                <FormLangRichEditor
                  name="description"
                  label={messages.subscription_description}
                  value={description}
                  onChange={(name, value) => {
                    this.changeDescription(name, value);
                  }}
                />
                <FormAutocomplete
                  onChange={(name, value) => this.setState({ type: value })}
                  label="Type"
                  name="type"
                  value=""
                  options={type_options.map(option => {
                    return { label: option, value: option };
                  })}
                />

                <FormInput
                  type="number"
                  label={messages.subscription_startingFee}
                  name="starting_fee"
                  onChange={(name, value) => this.setState({ starting_fee: value })}
                  value=""
                  disabled=""
                />
                <FormInput
                  type="number"
                  label={messages.subscription_fee}
                  name="fee"
                  onChange={(name, value) => this.setState({ fee: value })}
                  value=""
                  disabled=""
                />
                <div style={{ width: '150px' }}>
                  <h5>{messages.subscription_billing_period}</h5>
                  <IconRadioGroup
                    name="billingCycle"
                    variant="primary"
                    xinline
                    data={[{ value: 'monthly', label: messages.monthly }, { value: 'annual', label: messages.annual }]}
                    value={billingCycle}
                    onChange={this.setBillingCycle}
                  />
                </div>
                <div className="m-t-10 m-b-10">
                  <FormSwitchery
                    name="availability_period"
                    label={messages.subscription_set_availability_period}
                    value
                    checked={!!availabilityPeriod}
                    onChange={(name, value) => this.changeAvailabilityPeriod(value)}
                    disabled=""
                  />
                </div>
                {availabilityPeriod && (
                  <DateTimePicker
                    value={newDateTime}
                    label={messages.subscription_start}
                    locale={appIntl.locale}
                    displayTz={defaultTimezone}
                    onChange={this.setNewDateTime}
                    showClearDate
                    minDate={currentDateTime}
                    maxDate={newDateTimeUntil || null}
                  />
                )}
                {availabilityPeriod && (
                  <DateTimePicker
                    value={newDateTimeUntil}
                    label={messages.subscription_end}
                    locale={appIntl.locale}
                    displayTz={defaultTimezone}
                    onChange={this.setNewDateTimeUntil}
                    showClearDate
                    minDate={newDateTime && newDateTime >= currentDateTime ? newDateTime : currentDateTime}
                  />
                )}
                <h5>{messages.formGroup.user_roles}</h5>
                <div style={{ columnCount: '2', columnGap: '30px' }}>
                  {roles.data.list.map(role => {
                    const id = 'client-role-' + role;
                    return (
                      <div class="checkbox check-success" key={role}>
                        <input
                          /* disabled={this.checkDisabled()} */
                          id={id}
                          name="roles[]"
                          type="checkbox"
                          value={role}
                          /* checked={this.isChecked(role)} */
                          onChange={this.onChange}
                        />{' '}
                        <label htmlFor={id}>{role}</label>
                      </div>
                    );
                  })}
                </div>

                <div className="m-t-10">
                  <FormSwitchery
                    name="status"
                    label={messages.subscription_status}
                    value
                    checked={!!status}
                    onChange={(name, value) => this.changeStatus(value)}
                    disabled=""
                  />
                </div>
                {pending && <Loader />}
                <Button
                  onClick={() => this.createSubscription()}
                  disabled={isDisabled}
                  bsStyle="primary"
                  className="pull-right"
                  title="create_subscription"
                >
                  <span className="hidden-xs">{messages.create_subscription}</span>
                </Button>
              </div>
            </Col>
          </Row>
        </Modal.Body>
      </Modal>
    );
  }
}

const mapStateToProps = state => {
  return {
    appIntl: state.intl,
    user: state.login.user,
    subscriptions: state.list.subscriptions,
    defaultTimezone: getTimezoneFromState(state),
  };
};

const mapDispatchToProps = {
  addSubscriptionR,
};

export default withRouter(
  injectIntl(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(SubscriptionNew)
  )
);
